import Constant from '@/common/constant/Constant';
import Utils, {sortListByCorporationNameDictionartDESC } from '@/common/utils/utils';
import UpdateCorporationDetailSchema from '@/schema/UpdateCorporationDetailSchema'
import organizationService, { getCorporationById } from '@/service/organizationService';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { multiPanelAtom, reloadEditContractTabIdAtom } from '@/state/atom/panelAtom';
import {
    closePanelTabSelector,
    triggerReloadTicketListByPanelType
} from '@/state/selector/panelSelector';
import { yupResolver } from '@hookform/resolvers';
import { Button, IconButton, MenuItem, Select, TextField, Tooltip } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import FormInput from '../common/form/input';
import LoadingPanel from '../common/LoadingPanel';
import PhoneInput from 'react-phone-input-2';
import './rootOrganization.css';
import {
    getListUserInCorporation,
    handleChangeContractType,
    handleChangeStatusOrg,
    isDisableBtnSubmit,
    onCancelDialog,
    onChangeSelectedPersonInCharge,
    onConfirmCancelDialog,
    onSubmitDialog,
    onSubmitEditOrg,
    handleChangePermissionService,
    submitStatusService,
    onChangeSettingMaxStorage,
    getListB2BCutomer,
    disableScrollTypeNumberInput,
    isShowContractDate,
    onKeyDown,
    handleOnchangeLimitValue,
    checkWarningSetting,
    handleOnPaste,
    getUrlLinkCorporationDetails,
} from './EditOrganizationHandler';
import { Autocomplete } from '@material-ui/lab';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { userAtom } from '@/state/atom/userAtom';
import { useSnackbar } from 'notistack';
import ErrorHelper from '@/component/common/ErrorHelper';
import { getListProjectInCorporationForB2BCustomer } from '../../service/projectService';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';

export default function EditOrganization(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const corporationDetail = useRecoilValue(corporationAtom);
    const [organizationDetail, setOrganizationDetail] = useState({});
    const [contractType, setContractType] = useState('');
    const [statusOrg, setStatusOrg] = useState(Constant.CORPORATION_ACTIVE.ACTIVE);
    const [autoCompleteUserList, setAutoCompleteUserList] = useState([]);
    const [selectedPersonInCharge, setSelectedPersonInCharge] = useState({});
    const [mailAddress, setMailAddress] = useState('');
    const [isShowDialogCancel, setIsShowDialogCancel] = useState(false);
    const [isShowDialogSubmit, setIsShowDialogSubmit] = useState(false);
    const [triggerReload, setTriggerReload] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const userDetail = useRecoilValue(userAtom);
    const [reloadEditContractTabId, setReloadEditContractTabId] = useRecoilState(
        reloadEditContractTabIdAtom
    );
    const [isOpenPopupConfirmBlock, setIsPopupConfirmBlock] = useState(false);
    const [isOpenPopupConfirmUnlock, setIsPopupConfirmUnlock] = useState(false);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const [isOpenPopupConfirmDelete, setIsOpenPopupConfirmDelete] = useState(false);
    const [isOpenPopupCantNotDelete, setIsOpenPopupCantNotDelete] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [deskService, setDeskService] = useState({
        isOpenModal: false,
        isChecked: true,
        temporaryChecked: true
    });
    const [knowledgeService, setKnowledgeService] = useState({
        isOpenModal: false,
        isChecked: false,
        temporaryChecked: false
    });
    const [taskManagementService, setTaskManagementService] = useState({
        isOpenModal: false,
        isChecked: false,
        temporaryChecked: false
    });
    const [publicService, setPublicService] = useState({
        isOpenModal: false,
        isChecked: false,
        temporaryChecked: false
    });
    const [errorStorage, setErrorStorage] = useState('');

    const [maxStorage, setMaxStorage] = useState(0)

    const [isEdited, setIsEdited] = useState(false);
    const [listB2BCustomer, setListB2BCustomer] = useState([]);

    const [corporationPhone, setCorporationPhone] = useState('');
    const [maxTicket, setMaxTicket] = useState(0);
    const [maxGeneral, setMaxGeneral] = useState(0);

    const [warningMaxTicket, setWarningMaxTicket] = useState(false);
    const [warningMaxStorage, setWarningMaxStorage] = useState(false);

    const methods = useForm({
        mode: 'all',
        resolver: yupResolver(UpdateCorporationDetailSchema)
    });

    const { handleSubmit, errors, formState, getValues, setValue, reset, setError, register, clearErrors } = methods;
    const { isDirty, isValid } = formState;

    const invalidCharsLimitValue = [".", "-", "+", "e","E"];
    const invalidCharsStorage = ["-", "+", "e","E"];

    const argsAll = {
        ...props,
        API: props?.API,
        orgId: props.orgId,
        contractType,
        setContractType,
        statusOrg,
        setStatusOrg,
        setIsLoading,
        setAutoCompleteUserList,
        mailAddress,
        setMailAddress,
        selectedPersonInCharge,
        setSelectedPersonInCharge,
        getValues,
        formState,
        isDirty,
        isValid,
        setIsShowDialogCancel,
        setIsShowDialogSubmit,
        corporationDetail,
        userDetail,
        setTriggerReload,
        organizationDetail,
        enqueueSnackbar,
        panelList,
        setPanelList,
        reloadTicketListByPanelType,
        setDeskService,
        setKnowledgeService,
        setTaskManagementService,
        setIsEdited,
        isEdited,
        reset,
        errors,
        setError,
        setOrganizationDetail,
        setMaxStorage,
        maxStorage,
        setErrorStorage,
        errorStorage,
        setMaxTicket,
        maxGeneral,
        setMaxGeneral,
        maxTicket,
        setListB2BCustomer,
        clearErrors,

        warningMaxTicket,
        setWarningMaxTicket,
        warningMaxStorage,
        setWarningMaxStorage,
        setPublicService,
        publicService
    }

    const onClickBlockOrg = () => {
        setIsPopupConfirmBlock(true);
    };

    const onClickUnlockOrg = () => {
        setIsPopupConfirmUnlock(true);
    };

    const onSubmitUnlockOrg = async () => {
        try {
            setIsPopupConfirmUnlock(false);
            setIsLoading(true);
            const unlockResult = await organizationService.blockAndDeleteOrg(
                props?.API,
                organizationDetail.id,
                'UNLOCK'
            );
            enqueueSnackbar(I18n.get('COMMSG045'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
            setTriggerReload(!triggerReload);
        } catch (err) {
            setIsLoading(false);
        }
    };

    const onSubmitBlockOrg = async () => {
        try {
            setIsPopupConfirmBlock(false);
            setIsLoading(true);
            const blockResult = await organizationService.blockAndDeleteOrg(
                props?.API,
                organizationDetail.id,
                'BLOCK'
            );
            enqueueSnackbar(I18n.get('COMMSG045'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
            setTriggerReload(!triggerReload);
        } catch (err) {
            setIsLoading(false);
        }
    };

    const onClickDeleteOrg = id => {
        setIsOpenPopupConfirmDelete(true);
    };

    const onSubmitDeleteOrg = async () => {
        setIsOpenPopupConfirmDelete(false);
        setIsLoading(true);
        const deleteResult = await organizationService.blockAndDeleteOrg(
            props?.API,
            organizationDetail.id,
            'DELETE'
        );
        if (!deleteResult.success) {
            setIsOpenPopupCantNotDelete(true);
            setIsLoading(false);
            return;
        }
        enqueueSnackbar(I18n.get('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000
        });
        reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
        closePanelTab({
            event: null,
            panelType: Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT,
            panelId: props.panelId,
            tabId: props.tabId
        });
        setIsLoading(false);
    };

    //trigger reload tab when edit org from list org panel
    useEffect(() => {
        if (reloadEditContractTabId === organizationDetail?.id) {
            setTriggerReload(!triggerReload);
            setReloadEditContractTabId('tabId');
        }
    }, [reloadEditContractTabId]);

    // close panel when org isn't root
    useEffect(() => {
        register('telNumberCorporation');
        register(Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_GENERAL_USER);
        register(Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET);
    },[]);

    const onChangePhoneNumber = (phoneValue, country) => {
        setCorporationPhone(phoneValue);
        setIsEdited(true);
        if(phoneValue === country.dialCode) {
            setValue('telNumberCorporation', '');
            setError(
                'telNumberCorporation',
                { type: 'manual', message: I18n.get('COMMSG014') },
                { shouldFocus: false }
            );
        } else {
            setValue('telNumberCorporation', phoneValue);
            clearErrors('telNumberCorporation');
        }
    }

    const onBlurPhoneInput = (e, country) => {
        let phoneValue = e.target.value;
        phoneValue = phoneValue.substring(1);

        if(phoneValue === country.dialCode) {
            setValue('telNumberCorporation', '');
            setError(
                'telNumberCorporation',
                { type: 'manual', message: I18n.get('COMMSG014') },
                { shouldFocus: false }
            );
        } else {
            setValue('telNumberCorporation', phoneValue);
            clearErrors('telNumberCorporation');
        }
    }

    useEffect(() =>{
        if(!Utils.isEmptyString(corporationDetail.id)){
         if(corporationDetail.rootFlag !== Constant.ROOT_FLAG.TRUE){
            let newPanelList = panelList?.filter(panel => panel.type !== props.panelType && panel.type !== Constant.PANEL_TYPE.ROOT_LIST_ORG)
              setPanelList([...newPanelList])
         }
        }
    }, [corporationDetail, triggerReload]);

    useEffect(() => {
        setIsLoading(true);
        getCorporationById(props?.API, props.orgId)
            .then(async result => {
                let organizationData = { ...result };

                //close tab when org is deleted
                if (organizationData.active === Constant.CORPORATION_ACTIVE.DELETED) {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });
                    return;
                }
                setContractType(`${organizationData.contractType}`);

                setStatusOrg(organizationData.active);
                organizationData.name = Utils.getCorporationName(
                    Constant.LANGUAGE_TYPE.JP,
                    organizationData
                );
                setOrganizationDetail(organizationData);
                let listProjectB2BCustomer = await getListProjectInCorporationForB2BCustomer(props?.API,organizationData.id);

                if(!Utils.isEmptyArray(listProjectB2BCustomer)) {
                    await getListB2BCutomer(argsAll, listProjectB2BCustomer);
                }

                setDeskService({
                    isOpenModal: false,
                    isChecked: organizationData?.deskService,
                    temporaryChecked: organizationData?.deskService
                });
                setKnowledgeService({
                    isOpenModal: false,
                    isChecked: organizationData.knowledgeService,
                    temporaryChecked: organizationData.knowledgeService
                });
                setTaskManagementService({
                    isOpenModal: false,
                    isChecked: organizationData.taskManagementService,
                    temporaryChecked: organizationData.taskManagementService
                });
                setPublicService({
                    isOpenModal: false,
                    isChecked: organizationData.publicService,
                    temporaryChecked: organizationData.publicService
                });

                let maxStorageGB = Utils.convertByteToGigaByte(organizationData.limitValue.maxNumOfStorage, 3);

                setMaxStorage(maxStorageGB);

                await getListUserInCorporation(argsAll, organizationData);
                setValue('corporationName', organizationData.name);
                setValue('telNumberCorporation', organizationData.tel);
                setValue(Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_STORAGE, maxStorageGB);
                setCorporationPhone(organizationData.tel);
                setMaxGeneral(organizationData.limitValue?.maxNumOfGeneralUser)
                setMaxTicket(organizationData.limitValue?.maxNumOfTicket)

                checkWarningSetting(argsAll, organizationData);

                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            });
    }, [props.orgId, triggerReload]);

    const isGuestCorporation = () => {
        return [
            Constant.CORPORATION_CONTRACT_TYPE.GUEST,
            Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
        ].includes(organizationDetail.contractType)
    };

    return (
        <div className="groupUser">
            <LoadingPanel isLoading={isLoading} />
            <div className="head-btn">
                <div
                    className="head-btn-wrap"
                    style={{
                        minHeight: '32px',
                        float: 'right',
                        width: '100%',
                        justifyContent: 'flex-end'
                    }}
                >
                    <div className="btn-cancel">
                        <Button
                            className="btn-light btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={!(isDirty || isEdited)}
                            onClick={() => onCancelDialog(argsAll)}
                        >
                            {I18n.get('COMBTN001')}
                        </Button>
                    </div>
                    <div className="btn-submit">
                        <Button
                            className="btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={!isDisableBtnSubmit(argsAll)}
                            onClick={() => onSubmitDialog(argsAll)}
                        >
                            {I18n.get('COMBTN011')}
                        </Button>
                    </div>
                </div>
            </div>
            <div
                className="head-btn"
                style={{
                    width: '100%',
                    padding: '0px 0px 0px 0px'
                }}
            >
                <div
                    className="titleTicket"
                    style={{
                        width: '100%',
                        padding: '6px 16px 0px 16px'
                    }}
                >
                    <Tooltip title={organizationDetail?.name ? organizationDetail?.name: ''}>
                        <div className="titleDisplay titleTicket-titlev2">
                            {organizationDetail?.name}
                        </div>
                    </Tooltip>

                    <div className="titleTicket-btn titleTicket-btn-edit-org">
                        {organizationDetail.rootFlag !== 1 && (
                            <>
                                {organizationDetail.active ===
                                    Constant.CORPORATION_ACTIVE.ACTIVE && (
                                    <Tooltip title="運用停止">
                                        <div className="btnItem">
                                            <IconButton
                                                onClick={onClickBlockOrg}
                                                className="itemNav"
                                                data-cy="detail-ticket-icon-chat"
                                            >
                                                <img src="/assets/image/block-icon.svg" alt="" />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                )}

                                {[
                                    Constant.CORPORATION_ACTIVE.REJECT,
                                    Constant.CORPORATION_ACTIVE.WAITING_APPROVE
                                ].includes(organizationDetail.active) && (
                                    <Tooltip title="運用停止">
                                        <Button className="groupBtnOrgInCorp" disabled={true}>
                                            <img src="/assets/image/block-ico-disable.svg" alt="" />
                                        </Button>
                                    </Tooltip>
                                )}

                                {organizationDetail.active ===
                                    Constant.CORPORATION_ACTIVE.BLOCK && (
                                    <>
                                        <Tooltip title="停止解除">
                                            <div className="btnItem">
                                                <IconButton
                                                    className="itemNav"
                                                    data-cy="detail-ticket-icon-chat"
                                                    onClick={onClickUnlockOrg}
                                                >
                                                    <img
                                                        src="/assets/image/unlock-icon.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            </div>
                                        </Tooltip>
                                        <Tooltip title="削除">
                                            <div className="btnItem">
                                                <IconButton
                                                    onClick={onClickDeleteOrg}
                                                    className="itemNav"
                                                    data-cy="detail-ticket-icon-knowledge"
                                                >
                                                    <img
                                                        src="/assets/image/delete-icon.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            </div>
                                        </Tooltip>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div
                className="group-user"
                style={{
                    paddingTop: '16px'
                }}
            >
                {!Utils.isEmptyObject(organizationDetail) && (
                    <FormProvider {...methods}>
                        {/* org name  */}
                        <div className={'form-addTicket'}>
                            <label className="form-addTicket-label edit-organization-first-input-label">
                                組織名<span className="required">*</span>
                            </label>
                            <div className="form-addTicket-input">
                                <FormInput
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                    variant="outlined"
                                    name="corporationName"
                                    errorlist={errors}
                                    autoComplete="off"
                                    defaultValue={organizationDetail.name}
                                    value={organizationDetail.name}
                                    onKeyUp={() => setIsEdited(true)}
                                    placeholder={I18n.get('COMMSG067').replace(
                                        '{{item}}',
                                        '組織名'
                                    )}
                                />
                            </div>
                        </div>

                        {/* contract type  */}
                        <div className={'form-addTicket'}>
                            <label className="form-addTicket-label edit-organization-input-label">
                                契約タイプ
                            </label>
                            <div className="form-addTicket-input">
                                <Select
                                    className="form-control form-control--wrap form-control--hg32 edit-org-input"
                                    select
                                    variant="outlined"
                                    value={contractType}
                                    onChange={event => handleChangeContractType(event, argsAll)}
                                    disabled={true}
                                >
                                    <MenuItem value={Constant.CORPORATION_CONTRACT_TYPE.TRIAL}>
                                        {I18n.get('COMM01LB010')}
                                    </MenuItem>
                                    <MenuItem value={Constant.CORPORATION_CONTRACT_TYPE.STANDARD}>
                                        {I18n.get('COMM01LB010')}
                                    </MenuItem>
                                    <MenuItem value={Constant.CORPORATION_CONTRACT_TYPE.PREMIUM}>
                                        {I18n.get('COMM01LB010')}
                                    </MenuItem>
                                    <MenuItem value={Constant.CORPORATION_CONTRACT_TYPE.GUEST}>
                                        {I18n.get('TAGBTN025')}
                                    </MenuItem>
                                    <MenuItem value={Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK}>
                                        ゲストデスク
                                    </MenuItem>
                                </Select>
                            </div>
                        </div>

                        {/* status  */}
                        <div className={'form-addTicket'}>
                            <label className="form-addTicket-label edit-organization-input-label">
                                ステータス
                            </label>
                            <div className="form-addTicket-input">
                                <Select
                                    className="form-control form-control--wrap form-control--hg32 status-edit-org"
                                    select
                                    variant="outlined"
                                    value={statusOrg}
                                    disabled={true}
                                    onChange={event => handleChangeStatusOrg(event, argsAll)}
                                >
                                    <MenuItem value={`${Constant.CORPORATION_ACTIVE.ACTIVE}`}>
                                        Active
                                    </MenuItem>
                                    <MenuItem
                                        value={`${Constant.CORPORATION_ACTIVE.WAITING_APPROVE}`}
                                    >
                                        Waiting
                                    </MenuItem>
                                    <MenuItem value={`${Constant.CORPORATION_ACTIVE.REJECT}`}>
                                        Reject
                                    </MenuItem>
                                    <MenuItem value={`${Constant.CORPORATION_ACTIVE.BLOCK}`}>
                                        Block
                                    </MenuItem>
                                </Select>
                            </div>
                        </div>

                        {/* contract start date  */}
                        {isShowContractDate(organizationDetail) && (
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    契約開始日
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        name="startDate"
                                        className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                        variant="outlined"
                                        disabled={true}
                                        value={Utils.getDateByFormatYYYY_MM_DD(
                                            organizationDetail.createdAt
                                        )}
                                        autoComplete="off"
                                        data-cy="render-field-txt-input"
                                    />
                                </div>
                            </div>
                        )}

                        {/* contract update date  */}
                        {/* <div className={'form-addTicket'}>
                            <label className="form-addTicket-label edit-organization-input-label">
                                契約更新日
                            </label>
                            <div className="form-addTicket-input">
                                <TextField
                                    name="updateDate"
                                    className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                    variant="outlined"
                                    value={Utils.getDateByFormatYYYY_MM_DD(
                                        organizationDetail.contractDate
                                    )}
                                    autoComplete="off"
                                    disabled={true}
                                    data-cy="render-field-txt-input"
                                />
                            </div>
                        </div> */}

                        {/* pic: person in charge  */}
                        <div className={'form-addTicket'}>
                            <label className="form-addTicket-label edit-organization-input-label">
                                代表者名<span className="required">*</span>
                            </label>
                            <div className="form-addTicket-input edit-org-pic">
                                {!Utils.isEmptyObject(selectedPersonInCharge) && (
                                    <Autocomplete
                                        disableClearable
                                        id="persion-in-charge-org"
                                        getOptionLabel={option => option.label || ''}
                                        options={autoCompleteUserList}
                                        value={selectedPersonInCharge}
                                        onChange={(_, value) =>
                                            onChangeSelectedPersonInCharge(_, value, argsAll)
                                        }
                                        filterOptions={options =>
                                            options.filter(option =>
                                                [
                                                    Constant.PRIVILEGE_USER.ADMIN,
                                                    Constant.PRIVILEGE_USER.ADMIN_OWNER
                                                ].includes(option.privilege)
                                            )
                                        }
                                        renderOption={option => (
                                            <OverFlowTooltipWithTabsMui value={option.label || ''} />
                                        )}
                                        noOptionsText={I18n.get('COMMSG001')}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                className="form-control form-control--wrap form-control--hg32"
                                                error={
                                                    Utils.isEmptyObject(selectedPersonInCharge) ||
                                                    selectedPersonInCharge?.id === null
                                                }
                                                helperText={
                                                    Utils.isEmptyObject(selectedPersonInCharge) ||
                                                    selectedPersonInCharge?.id === null
                                                        ? I18n.get('COMMSG014')
                                                        : ''
                                                }
                                            />
                                        )}
                                    />
                                )}
                            </div>
                        </div>

                        {/* mail admin */}
                        <div className={'form-addTicket'}>
                            <label className="form-addTicket-label edit-organization-input-label">
                                メール<span className="required">*</span>
                            </label>
                            <div className="form-addTicket-input">
                                <TextField
                                    name="mailAdmin"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                    variant="outlined"
                                    autoComplete="off"
                                    value={mailAddress}
                                    data-cy="render-field-txt-input"
                                    disabled={true}
                                />
                            </div>
                        </div>

                        {/* tel number  */}
                        <div className="form-addTicket">
                            <label className="form-addTicket-label edit-organization-input-label">
                                電話番号<span className="required">*</span>
                            </label>
                            <PhoneInput
                                country={'jp'}
                                value={corporationPhone}
                                onChange={onChangePhoneNumber}
                                onBlur={onBlurPhoneInput}
                                countryCodeEditable={false}
                                placeholder={I18n.get('COMMSG067').replace(
                                    '{{item}}',
                                    '電話番号'
                                )}
                                inputProps={{
                                    name: 'telNumberCorporation',
                                    className: 'form-control edit-org-input',
                                    variant: 'outlined',
                                    size: 'small',
                                }}
                                data-cy="create-org-input-corp-phone"
                            />
                            <div style={{marginTop: '5px'}}>
                                <ErrorHelper
                                    isShowError={
                                        errors && errors.hasOwnProperty('telNumberCorporation')
                                    }
                                    textError={errors['telNumberCorporation']?.message}
                                />
                            </div>
                        </div>
                        {/* url  */}
                        <div className={'form-addTicket'}>
                            <label className="form-addTicket-label edit-organization-input-label">
                                URL (ご利用の組織ID)
                            </label>
                            <div className="form-addTicket-input">
                                <TextField
                                    name="subDomainCorportion"
                                    className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                    variant="outlined"
                                    autoComplete="off"
                                    disabled={true}
                                    value={getUrlLinkCorporationDetails(organizationDetail)}
                                    data-cy="render-field-txt-input"
                                />
                            </div>
                        </div>

                        {/* setting limit value  */}
                        <div className="add-border">
                            {/* max general user */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    利用可能なMaxのジェネラルユーザーID数
                                    <span className="required">*</span>
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        name={Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_GENERAL_USER}
                                        className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                        variant="outlined"
                                        type="number"
                                        value={maxGeneral}
                                        onKeyDown={(e) => onKeyDown(e, invalidCharsLimitValue)}
                                        onChange={e => handleOnchangeLimitValue(e, argsAll, Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_GENERAL_USER)}
                                        onPaste={(e) => handleOnPaste(e, invalidCharsLimitValue)}
                                        placeholder={I18n.get('USER14P001')}
                                        onWheel={(e) => disableScrollTypeNumberInput(e)}
                                        disabled={isGuestCorporation()}
                                    />
                                    <div style={{marginTop: '5px'}}>
                                        <ErrorHelper
                                            isShowError={
                                                errors && errors.hasOwnProperty(Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_GENERAL_USER)
                                            }
                                            textError={errors[Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_GENERAL_USER]?.message}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* used general user  */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    実際に使われているジェネラルユーザーID数
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        disabled={true}
                                        name="currentGeneralUser"
                                        className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                        variant="outlined"
                                        autoComplete="off"
                                        defaultValue={organizationDetail.limitValue?.numOfGeneralUser}
                                        value={organizationDetail.limitValue?.numOfGeneralUser}
                                        data-cy="render-field-txt-input"
                                        style={{
                                            backgroundColor: 'rgba(199, 202, 209, 1)'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* used internal user  */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    実際に使われているインターナルユーザー数
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        disabled={true}
                                        name="currentInternalUser"
                                        className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                        variant="outlined"
                                        autoComplete="off"
                                        defaultValue={organizationDetail.limitValue?.numOfInternalUser}
                                        value={organizationDetail.limitValue?.numOfInternalUser}
                                        data-cy="render-field-txt-input"
                                        style={{
                                            backgroundColor: 'rgba(199, 202, 209, 1)'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* used b2c customer in org  */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    実際に使われているB2Cカスタマーユーザー数
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        disabled={true}
                                        name="currentB2CCustomer"
                                        className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                        variant="outlined"
                                        autoComplete="off"
                                        defaultValue={organizationDetail.limitValue?.numOfB2CCustomer}
                                        value={organizationDetail.limitValue?.numOfB2CCustomer}
                                        data-cy="render-field-txt-input"
                                        style={{
                                            backgroundColor: 'rgba(199, 202, 209, 1)'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* max ticket */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    発行可能なMaxのチケット数
                                    <span className="required">*</span>
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        name={Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET}
                                        className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                        variant="outlined"
                                        type="number"
                                        value={maxTicket}
                                        onKeyDown={(e) => onKeyDown(e, invalidCharsLimitValue)}
                                        onPaste={(e) => handleOnPaste(e, invalidCharsLimitValue)}
                                        onChange={e => handleOnchangeLimitValue(e, argsAll, Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET)}
                                        placeholder={I18n.get('USER14P001')}
                                        onWheel={(e) => disableScrollTypeNumberInput(e)}
                                        disabled={isGuestCorporation()}
                                    />
                                    {errors && errors.hasOwnProperty(Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET) ? 
                                        <div style={{marginTop: '5px'}}>
                                            <ErrorHelper
                                                isShowError={
                                                    errors && errors.hasOwnProperty(Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET)
                                                }
                                                textError={errors[Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET]?.message}
                                            />
                                        </div> :
                                        <div style={{marginTop: '5px'}}>
                                            <ErrorHelper
                                                isShowError={warningMaxTicket}
                                                textError={I18n.get('USER14MSG015')}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>

                            {/* used ticket */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    発行しているチケット数
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        disabled={true}
                                        name="usedTicket"
                                        className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                        variant="outlined"
                                        autoComplete="off"
                                        defaultValue={organizationDetail.limitValue?.numOfTicket}
                                        value={organizationDetail.limitValue?.numOfTicket}
                                        data-cy="render-field-txt-input"
                                        style={{
                                            backgroundColor: 'rgba(199, 202, 209, 1)'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* max storage  */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    ストレッジ容量上限
                                    <span className="required">*</span>
                                </label>
                                <div className="form-addTicket-input storage-wrapper">
                                    <TextField
                                        name={Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_STORAGE}
                                        className="form-control form-control--wrap form-control--hg40 edit-org-input max-storage-org"
                                        error={!Utils.isEmptyString(errorStorage)}
                                        autoComplete="off"
                                        value={maxStorage}
                                        placeholder={I18n.get('USER14P001')}
                                        onKeyDown={(e) => onKeyDown(e, invalidCharsStorage)}
                                        onPaste={(e) => handleOnPaste(e, invalidCharsStorage)}
                                        variant="outlined"
                                        type="number"
                                        onChange={(e) => onChangeSettingMaxStorage(e, argsAll)}
                                        data-cy="render-field-txt-input"
                                        onWheel={(e) => disableScrollTypeNumberInput(e)}
                                        disabled={isGuestCorporation()}
                                    />
                                    <span className='storage-wrapper-label'>Gb</span>
                                </div>
                            </div>
                            {errorStorage ? 
                                <div style={{padding: '0 16px', marginTop: '5px'}}>
                                    <ErrorHelper isShowError={errorStorage} textError={errorStorage}/>
                                </div> :
                                <div style={{padding: '0 16px', marginTop: '5px'}}>
                                    <ErrorHelper isShowError={warningMaxStorage} textError={I18n.get('USER14MSG016')}/>
                                </div>
                            }

                            {/* used storage  */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    使われているストレッジ総量
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        disabled={true}
                                        name="usedStorage"
                                        className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                        variant="outlined"
                                        autoComplete="off"
                                        defaultValue={Utils.convertByteToGigaByte(organizationDetail.limitValue?.numOfStorage, 6)}
                                        value={Utils.convertByteToGigaByte(organizationDetail.limitValue?.numOfStorage, 6)}
                                        data-cy="render-field-txt-input"
                                        style={{
                                            backgroundColor: 'rgba(199, 202, 209, 1)'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* used knowledge  */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    発行しているナレッジ数
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        disabled={true}
                                        name="usedKnowledge"
                                        className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                        variant="outlined"
                                        autoComplete="off"
                                        defaultValue={organizationDetail.limitValue?.numOfTicketKnowledge}
                                        value={organizationDetail.limitValue?.numOfTicketKnowledge}
                                        data-cy="render-field-txt-input"
                                        style={{
                                            backgroundColor: 'rgba(199, 202, 209, 1)'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* used project  */}
                            <div className={'form-addTicket'}>
                                <label className="form-addTicket-label edit-organization-input-label">
                                    作成されているプロジェクト数
                                </label>
                                <div className="form-addTicket-input">
                                    <TextField
                                        disabled={true}
                                        name="usedProject"
                                        className="form-control form-control--wrap form-control--hg40 edit-organization-disable-input edit-org-input"
                                        variant="outlined"
                                        autoComplete="off"
                                        defaultValue={organizationDetail.limitValue?.numOfGeneralProject}
                                        value={organizationDetail.limitValue?.numOfGeneralProject}
                                        data-cy="render-field-txt-input"
                                        style={{
                                            backgroundColor: 'rgba(199, 202, 209, 1)'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* list b2b  customer*/} 
                            <div className="form-addTicket">
                                <label className="form-addTicket-label edit-organization-input-label">
                                    カスタマ一覧
                                </label>
                                <div className="org-detail-b2b-cutomer-list">
                                    {!Utils.isEmptyArray(listB2BCustomer) &&
                                        sortListByCorporationNameDictionartDESC(listB2BCustomer).map(item => (
                                            <div className='name-b2b-customer'>
                                                <div className='dot'>.</div>
                                                <OverFlowTooltipWithTabsMui value={item.name}/>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </FormProvider>
                )}

                {/* setting permission  */}
                <div className="edit-org-function-setting">
                    <div
                        className="titleTicket "
                        style={{
                            width: '100%',
                            padding: '6px 16px 0px 16px'
                        }}
                    >
                        <div className="function-setting-title">提供する機能設定</div>
                    </div>

                    {/* service desk  */}
                    <div className="functionSetting">
                        <span className="functionSetting-label">{I18n.get('USER14LB010')}</span>
                        <div className="switch-check">
                            <input
                                id={I18n.get('USER14LB010')}
                                type="checkbox"
                                checked={deskService.isChecked}
                                onChange={e => handleChangePermissionService(e, argsAll)}
                            />
                            <label htmlFor={I18n.get('USER14LB010')}></label>
                        </div>
                    </div>

                    {/* knowledge management  */}
                    <div className="functionSetting">
                        <span className="functionSetting-label">{I18n.get('USER14LB011')}</span>
                        <div className="switch-check">
                            <input
                                id={I18n.get('USER14LB011')}
                                type="checkbox"
                                checked={knowledgeService.isChecked}
                                onChange={e => handleChangePermissionService(e, argsAll)}
                                disabled={publicService.isChecked}
                            />
                            <label htmlFor={I18n.get('USER14LB011')}></label>
                        </div>
                    </div>

                    {/* public knowledge service  */}
                    <div className="functionSetting">
                        <span className="functionSetting-label">{I18n.get('USER14LB013')}</span>
                        <div className="switch-check">
                            <input
                                id={I18n.get('USER14LB013')}
                                type="checkbox"
                                checked={publicService.isChecked}
                                onChange={e => handleChangePermissionService(e, argsAll)}
                                disabled={!knowledgeService.isChecked}
                            />
                            <label htmlFor={I18n.get('USER14LB013')}></label>
                        </div>
                    </div>

                    {/* task management  */}
                    <div className="functionSetting">
                        <span className="functionSetting-label">{I18n.get('USER14LB012')}</span>
                        <div className="switch-check">
                            <input
                                id={I18n.get('USER14LB012')}
                                type="checkbox"
                                checked={taskManagementService.isChecked}
                                onChange={e => handleChangePermissionService(e, argsAll)}
                            />
                            <label htmlFor={I18n.get('USER14LB012')}></label>
                        </div>
                    </div>
                </div>
            </div>

            {/* modal cancel  */}
            <ConfirmDialog
                isOpen={isShowDialogCancel}
                msgConfirm={I18n.get('USER12MSG010')}
                okCallBack={() => onConfirmCancelDialog(argsAll)}
                closeCallBack={() => setIsShowDialogCancel(false)}
                textClose={I18n.get('COMBTN007')}
            />

            {/* modal submit  */}
            <ConfirmDialog
                isOpen={isShowDialogSubmit}
                msgConfirm={I18n.get('COMMSG004')}
                okCallBack={handleSubmit(async () => await onSubmitEditOrg(argsAll))}
                closeCallBack={() => setIsShowDialogSubmit(false)}
                textClose={I18n.get('COMBTN007')}
            />

            {/* modal desk service */}
            <ConfirmDialog
                isOpen={deskService.isOpenModal}
                msgConfirm={
                    deskService.isChecked ? I18n.get('USER14MSG004') : I18n.get('USER14MSG005')
                }
                okCallBack={async () =>
                    await submitStatusService(
                        argsAll,
                        deskService,
                        Constant.UPDATE_CORP_DETAIL_METHOD.DESK_SERVICE
                    )
                }
                closeCallBack={() => setDeskService(prev => ({ ...prev, isOpenModal: false }))}
                textClose={I18n.get('COMBTN007')}
            />

            {/* modal knowledge service */}
            <ConfirmDialog
                isOpen={knowledgeService.isOpenModal}
                msgConfirm={
                    knowledgeService.isChecked ? I18n.get('USER14MSG006') : I18n.get('USER14MSG007')
                }
                okCallBack={async () =>
                    await submitStatusService(
                        argsAll,
                        knowledgeService,
                        Constant.UPDATE_CORP_DETAIL_METHOD.KNOWLEDGE
                    )
                }
                closeCallBack={() => setKnowledgeService(prev => ({ ...prev, isOpenModal: false }))}
                textClose={I18n.get('COMBTN007')}
            />

            {/* modal publick knowledge service  */}
            <ConfirmDialog
                isOpen={publicService.isOpenModal}
                msgConfirm={
                    publicService.isChecked ? I18n.get('USER14MSG024') : I18n.get('USER14MSG025')
                }
                okCallBack={async () =>
                    await submitStatusService(
                        argsAll,
                        publicService,
                        Constant.UPDATE_CORP_DETAIL_METHOD.PUBLIC_SERVICE
                    )
                }
                closeCallBack={() => setPublicService(prev => ({ ...prev, isOpenModal: false }))}
                textClose={I18n.get('COMBTN007')}
            />

            <ConfirmDialog
                isOpen={isOpenPopupConfirmBlock}
                msgConfirm={I18n.get('USER14MSG002')}
                closeCallBack={() => {
                    setIsPopupConfirmBlock(false);
                }}
                okCallBack={onSubmitBlockOrg}
                textSubmit="はい"
                textClose="いいえ"
            />
            <ConfirmDialog
                isOpen={isOpenPopupConfirmUnlock}
                msgConfirm={I18n.get('USER14MSG003')}
                closeCallBack={() => {
                    setIsPopupConfirmUnlock(false);
                }}
                okCallBack={onSubmitUnlockOrg}
                textSubmit="はい"
                textClose="いいえ"
            />
            <ConfirmDialog
                isOpen={isOpenPopupConfirmDelete}
                msgConfirm={I18n.get('USER14MSG001')}
                closeCallBack={() => {
                    setIsOpenPopupConfirmDelete(false);
                }}
                okCallBack={onSubmitDeleteOrg}
                textSubmit="はい"
                textClose="いいえ"
            />
            <ConfirmDialog
                isOpen={isOpenPopupCantNotDelete}
                msgConfirm={I18n.get('USER14MSG001-1')}
                okCallBack={() => {
                    setIsOpenPopupCantNotDelete(false);
                }}
                textSubmit="はい"
                textClose="いいえ"
            />
        </div>
    );
}
